import { render, staticRenderFns } from "./OJobAllocation.vue?vue&type=template&id=537b20f0&scoped=true&"
import script from "./OJobAllocation.vue?vue&type=script&lang=js&"
export * from "./OJobAllocation.vue?vue&type=script&lang=js&"
import style0 from "./OJobAllocation.vue?vue&type=style&index=0&id=537b20f0&scoped=true&lang=css&"
import style1 from "./OJobAllocation.vue?vue&type=style&index=1&lang=css&"
import style2 from "./OJobAllocation.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537b20f0",
  null
  
)

export default component.exports